var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { cva } from 'class-variance-authority';
import { Slot } from 'radix-ui';
import { cn } from '../../../lib/utils.js';
var badgeVariants = cva('inline-flex w-fit shrink-0 items-center justify-center gap-1 overflow-hidden rounded-full border border-transparent px-2 py-0.5 text-xs font-medium whitespace-nowrap transition-[color,box-shadow] focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring/70 aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 [&>svg]:pointer-events-none [&>svg]:size-3', {
    variants: {
        variant: {
            default: 'bg-primary text-primary-foreground [a&]:hover:bg-primary/90',
            secondary: 'bg-secondary text-secondary-foreground [a&]:hover:bg-secondary/90',
            destructive: 'bg-destructive text-white focus-visible:ring-destructive/70 dark:bg-destructive/60 [a&]:hover:bg-destructive/90',
            outline: 'border-border text-foreground [a&]:hover:bg-accent [a&]:hover:text-accent-foreground',
            ghost: '[a&]:hover:bg-accent [a&]:hover:text-accent-foreground',
            link: 'text-primary underline-offset-4 [a&]:hover:underline',
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});
function Badge(_a) {
    var className = _a.className, _b = _a.variant, variant = _b === void 0 ? 'default' : _b, _c = _a.asChild, asChild = _c === void 0 ? false : _c, props = __rest(_a, ["className", "variant", "asChild"]);
    var Comp = asChild ? Slot.Root : 'span';
    return (<Comp data-slot="badge" data-variant={variant} className={cn(badgeVariants({ variant: variant }), className)} {...props}/>);
}
export { Badge, badgeVariants };
